export const events = {
  filters: {
    change: 'Go to org chart filters',
  },

  findMeButton: {
    click: 'Click Find me button from Org Chart',
  },

  sidepanel: {
    close: 'Org chart sidepanel cancel',
    footerActionClick: 'Go to employee profile from org chart',
    tabs: {
      profileClick: 'Go to employee org chart sidepanel profile',
      reportsClick: 'Go to employee org chart sidepanel Reports',
    },
    reportsCost: {
      moreDetailsClick: 'Go to more reports cost details from org chart',
    },
    assignJobsHint: {
      action: 'Assign job through the side panel hint done',
    },
  },

  nodes: {
    employee: {
      click: 'Go to employee sidepanel',
    },
    managers: {
      click: 'Go to managers reporting from Org Chart',
    },
    addPosition: {
      click: 'Create vacant position from org chart start',
      form: {
        selectJobPosting: 'Link job opening to org chart vacant position',
        selectJobRole: 'Choose Role to org chart vacant position',
        selectJobLevel: 'Choose level to org chart vacant position',
        submit: 'Add vacant position to org chart submit',
      },
      hint: {
        action: 'Add vacant position hint next',
        close: 'Hint component cancel',
      },
    },
    position: {
      click: 'Click vacant position from org chart',
      navigate: 'Go to job opening from org chart',
      publicPage: 'Go to public page from org chart',
      remove: 'Remove vacant position from org chart',
    },
  },
}
